import { gql } from "@apollo/client";

export const USAGE_OF_SUBACCOUNT = gql`
  query usageOfSubaccount(
    $subaccountId: ID!
    $startDate: String!
    $endDate: String!
  ) {
    usageOfSubaccountByDay(
      subaccountId: $subaccountId
      startDate: $startDate
      endDate: $endDate
    ) {
      date
      calls
      voicemails
    }
    usageOfSubaccountByCampaign(
      subaccountId: $subaccountId
      startDate: $startDate
      endDate: $endDate
    ) {
      campaign {
        id
        name
      }
      calls
      voicemails
    }
  }
`;

export const USAGE_OF_TENANT = gql`
  query usageOfTenant($startDate: String!, $endDate: String!) {
    usageOfTenantBySubaccount(startDate: $startDate, endDate: $endDate) {
      subaccount {
        id
        name
      }
      calls
      voicemails
    }
    usageOfTenantByDay(startDate: $startDate, endDate: $endDate) {
      date
      calls
      voicemails
    }
  }
`;
